import {type DefaultError, type UseMutationOptions, useMutation} from '@tanstack/react-query'

import {fetchAcceptOffer} from './fetch'
import type {AcceptOfferRequest, AcceptOfferResponse} from './model/types'

/**
 * Хук на принятие оффера
 * @param options Параметры useMutation
 */
export function useAcceptOffer(
  options?: Omit<UseMutationOptions<AcceptOfferResponse, DefaultError, AcceptOfferRequest>, 'mutationFn'>,
) {
  return useMutation({...options, mutationFn: fetchAcceptOffer})
}
